















import { Component, Vue } from 'vue-property-decorator';

import { curPref, Preferences } from '@/services/Preferences';

import VueError from '@/components/VueError.vue';
import NavBar from '@/components/NavBar.vue';
import SubList from '@/components/subscriptions/SubList.vue';

@Component({
  components: {
    VueError,
    NavBar,
    SubList
  },
})
export default class Access extends Vue {

  curSection:string = curPref.retrieve('v3-subs-cur-section', 'subscriptions');
  error:string = '';
  
  async mounted() {
    // nothing to do yet
  }

  navbarClickHandler(newSection:string) {
    curPref.store('v3-subs-cur-section', newSection);
    this.curSection = newSection;
  }

}
